<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,7C15,7,11.86,7,11.86,7C11.41,5.28,9.86,4,8,4C6.14,4,4.59,5.28,4.14,7C4.14,7,1,7,1,7C0.45,7,0,7.45,0,8C0,8.55,0.45,9,1,9C1,9,4.14,9,4.14,9C4.59,10.719999999999999,6.14,12,8,12C9.86,12,11.41,10.719999999999999,11.86,9C11.86,9,15,9,15,9C15.55,9,16,8.55,16,8C16,7.45,15.55,7,15,7C15,7,15,7,15,7ZM8,10C6.9,10,6,9.1,6,8C6,6.9,6.9,6,8,6C9.1,6,10,6.9,10,8C10,9.1,9.1,10,8,10C8,10,8,10,8,10Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'GitCommit',
} as DefineComponent
</script>
